export const schoolYearFromDate = (date = new Date()): string => {
  const month = date.getMonth();
  if (month <= 2) {
    return (date.getFullYear() - 1).toString();
  } else {
    return date.getFullYear().toString();
  }
};
